<template>
    <v-card class="container pa-6 mx-sm-8 mb-sm-12"
            flat
            tile>
        <h1 class="title">
            {{ $vuetify.lang.t('$vuetify.page_headline.reset_pw') }}
        </h1>

        <template v-if="complete === null">
            <p>
                {{ $vuetify.lang.t('$vuetify.page_description.reset_pw') }}
            </p>

            <v-form ref="form"
                    v-model="valid"
                    lazy-validation>

                <v-text-field name="email"
                              filled
                              :label="$vuetify.lang.t('$vuetify.form_items.email')"
                              :rules="rules.email"
                              v-model="form.email"
                              :disabled="whileSubmitting"
                              autocomplete="email"
                              required></v-text-field>

                <v-btn @click="submit"
                       block
                       large
                       class="mt-4 mb-4"
                       :loading="whileSubmitting"
                       :disabled="whileSubmitting || !valid"
                       color="primary darken-1">
                    {{ $vuetify.lang.t('$vuetify.buttons.reset_pw') }}
                </v-btn>
            </v-form>
        </template>
        <template v-else-if="complete">
            <p v-html="$vuetify.lang.t('$vuetify.page_description.reset_pw_success')"></p>
            <p v-html="$vuetify.lang.t('$vuetify.page_description.reset_pw_success_additional')"></p>
        </template>
        <template v-else-if="!complete">
            <p v-html="$vuetify.lang.t('$vuetify.page_description.reset_pw_failed')"></p>
            <v-btn @click="resetForm"
                   block
                   large
                   class="mt-4 mb-4"
                   color="primary">
                {{ $vuetify.lang.t('$vuetify.buttons.try_again') }}
            </v-btn>
        </template>
    </v-card>
</template>
<script>
    // models
    import User from '../../models/User';

    // utils
    import { email } from '../../utils/formRules';
    import { setPageTitle } from '../../utils/helper';
    import {
        LOADER_RESET_PASSWORD,
    } from '../../utils/constants';

    export default {
        name: 'reset-password',
        computed: {
            whileSubmitting() {
                return this.$wait.waiting(LOADER_RESET_PASSWORD);
            },
        },
        data() {
            return {
                complete: null,
                valid: true,
                form: {
                    email: '',
                },
                rules: {
                    email,
                },
            }
        },
        methods: {
            async submit() {
                if (!this.$refs.form.validate()) return false;

                this.complete = await User.resetPassword(this.form).catch(console.error);
            },
            resetForm() {
                this.complete = null;
                this.form = {
                    email: '',
                };
            }
        },
    }
</script>
